import React, { useState } from "react";
import { observer } from "mobx-react";
import { Modal, Text, Group, Button, TextInput } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import GenericEstimatedFee from "../genericEstimated";
import { MODALS } from "../../helpers/constants";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";
import { IconCircleMinus } from "@tabler/icons-react";

const CloseChannel = observer(({ cubby }: { cubby: Cubby }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");

  const getAliasOrPublicKey = (alias: string, publicKey: string) => {
    return alias ? alias : publicKey.slice(0, 10);
  };

  const calculateReappearanceTime = (csvDelay: number) => {
    const averageBlockTimeMinutes = 10;
    const hours = (csvDelay * averageBlockTimeMinutes) / 60;
    return Math.round(hours);
  };

  const channel = cubby.currentlyFocusedChannelDataForChannelClosure;

  const handleCloseChannel = () => {
    setIsLoading(true);
    let publicKey = null;
    let socket = null;
    socket = cubby.peerLists.data.find(
      (peer) => peer.public_key === channel.partner_public_key
    )?.socket;
    const isCooperativeClose = channel.is_active == true && socket;
    if (isCooperativeClose) {
      publicKey = channel.partner_public_key;
      socket = socket;
    }
    const transactionId = channel.channel_point.split(":")[0];
    const transactionVOut = channel.channel_point.split(":")[1];

    cubby.cubbyLife("close_channel", {
      socket: socket,
      publicKey: publicKey,
      isForcedClose: !isCooperativeClose,
      transactionId: transactionId,
      transactionVOut: transactionVOut,
    });

    setTimeout(() => {
      setConfirmationText("");
      cubby.setModal(null);
      cubby.setCurrentlyFocusedChannelTransactionIdForChannelClosure(null);
      setIsLoading(false);
    }, 2000);
  };

  const handleCloseModal = () => {
    cubby.setCurrentlyFocusedChannelTransactionIdForChannelClosure(null);
  };

  const reappearanceTime = calculateReappearanceTime(
    channel?.raw_data.local_csv
  );

  return (
    <>
      {cubby.currentlyFocusedChannelTransactionIdForChannelClosure && (
        <Modal
          opened={!!cubby.currentlyFocusedChannelTransactionIdForChannelClosure}
          onClose={handleCloseModal}
          title={
            <TextWithInfoAndIcon
              text="Confirm Channel Closure"
              articleSlug={ARTICLES.CLOSING_CHANNELS.slug}
              icon={<IconCircleMinus size={24} />}
              cubby={cubby}
              textSize="lg"
            />
          }
          centered
        >
          <Text>
            Are you sure you want to close this channel with{" "}
            <strong>
              {getAliasOrPublicKey(channel?.alias, channel?.partner_public_key)}
            </strong>
            ?
          </Text>

          <Text>
            Please note: if this channel is currently offline, we'll need to
            force-close it. Your funds in this channel will reappear in your
            wallet after about {reappearanceTime} hours.
          </Text>

          {/* {!channel.is_active && (
            <Text color="red" mt="sm">
            
            </Text>
          )} */}
          {channel.is_partner_initiated == false && (
            <GenericEstimatedFee cubby={cubby} />
          )}
          <TextInput
            label="Type 'close' to confirm"
            placeholder="close"
            value={confirmationText}
            onChange={(event) =>
              setConfirmationText(event.currentTarget.value.toLocaleLowerCase())
            }
            mt="md"
          />
          <Group justify="flex-end" mt="lg">
            <Button
              variant="outline"
              onClick={handleCloseModal}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              color="red"
              onClick={handleCloseChannel}
              loading={isLoading}
              disabled={confirmationText !== "close"}
            >
              Close Channel
            </Button>
          </Group>
        </Modal>
      )}
    </>
  );
});

export default CloseChannel;
